import { toast } from 'react-toastify';
import CourseDropdown from '../../../Common/Component/CourseDropdown';
import GenerateDropdown from '../../../CommonElements/GenerateDropdown';
import SeachBar from '../../UiKits/SearchBar';
import { getCertificateForCourse } from '../../../utils/certificateHandles';

const CertificateHeader = ({ activeCourse, search, setSearch, loading, filteredStudent, selectedStudents, handleGenerate, handleDownload, mainLoading, setMainLoading }) => {

    const getCertificates = (studentsData) => {
        return studentsData?.flatMap((student) => {
            const certificate = getCertificateForCourse(student, activeCourse?.id);
            if (!certificate) {
                toast.error(`No certificate found for ${student.fullName}`);
                return;
            }
            return {
                ...certificate,
                email: student.email,
            };
        });
    };

    const onGenerate = async (studentsData) => {
        setMainLoading(true);
        await handleGenerate(studentsData);
        setMainLoading(false);
    }

    const onDownload = async (data) => {
        setMainLoading(true);
        const certs = getCertificates(data);
        if (!certs?.length || certs?.every((cert) => !cert?.url)) {
            toast.error("No certificates to download");
            setMainLoading(false);
            return;
        }
        await handleDownload(certs);
        setMainLoading(false);
    }

    return (
        <div className="header-row">
            <CourseDropdown isCertificate={true} selectCourse={activeCourse?.id} />
            <SeachBar search={search} setSearch={setSearch} loading={loading} />
            <div className="generate-menu">
                <GenerateDropdown
                    onGenerateAll={() => onGenerate(filteredStudent)}
                    onGenerateSelected={() => onGenerate(selectedStudents)}
                    onDownloadAll={() => onDownload(filteredStudent)}
                    onDownloadSelected={() => {
                        if (!selectedStudents?.length) return toast.error("No students selected");
                        onDownload(selectedStudents)
                    }}
                    mainLoading={mainLoading}
                />
            </div>

        </div>
    )
}

export default CertificateHeader;